import React from 'react';
import { FormattedMessage } from 'react-intl';

import Button from '@atlaskit/button/loading-button';

import { i18n } from '../../AdvancedSearch-i18n.ts';

import { SearchPaginationContainer } from './styled.tsx';

interface SearchPaginationProps {
	loading: boolean;
	hasNextPage: boolean;
	loadMore: () => void;
}

export const SearchPagination = ({
	loading,
	hasNextPage,
	loadMore,
}: SearchPaginationProps): React.JSX.Element | null => {
	return hasNextPage ? (
		<SearchPaginationContainer loading={loading}>
			<Button
				onClick={loadMore}
				isLoading={loading}
				data-test-id="load-more-button"
				testId="load-more-button"
			>
				<FormattedMessage {...i18n.paginationLoadMoreButton} />
			</Button>
		</SearchPaginationContainer>
	) : null;
};
